<template>
	<div
		class="g-block-body-line-dot-right g-block-body-padding"
		:class="{
			'g-block-body-line-dot-right--edit': editable,
			'is-active': editable && active,
			'g-block-body-line-dot-right--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-body-line-dot-right__card">
			<div class="g-block-body-line-dot-right__head">
				<div class="g-block-body-line-dot-right__rail">
					<span
						class="g-block-body-line-dot-right__line"
						:style="{ background: themeColor }"
						aria-hidden="true"
					></span>
					<span
						class="g-block-body-line-dot-right__dot"
						:style="{ background: themeColor }"
						aria-hidden="true"
					></span>
				</div>
				<RichTextEditable
					v-if="editable"
					class="g-block-body-line-dot-right__title"
					fit-content
					:style="{ color: themeColor }"
					:model-value="data.title"
					placeholder="请输入标题"
					@update:model-value="onTitleUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-body-line-dot-right__title"
					:style="{ color: themeColor }"
					v-html="data.title || ''"
				></div>
			</div>
			<RichTextEditable
				v-if="editable"
				class="g-block-body-line-dot-right__text"
				:style="{ color: themeColor }"
				:model-value="data.content"
				placeholder="请输入正文"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-body-line-dot-right__text"
				:style="{ color: themeColor }"
				v-html="data.content || ''"
			></div>
			<div
				class="g-block-body-line-dot-right__footer"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { bodyCardMixin } from '../shared/bodyCardMixin.js';

	export default {
		name: 'GBlockBodyLineDotRight',
		components: { RichTextEditable },
		mixins: [bodyCardMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';
	@import '../shared/lineDotCard.less';

	.g-block-body-line-dot-right {
		.body-block-edit-shell();
	}

	.g-block-body-line-dot-right__card {
		.line-dot-card-shell();
	}

	.g-block-body-line-dot-right__head {
		.line-dot-card-head();
	}

	.g-block-body-line-dot-right__rail {
		.line-dot-card-rail();
	}

	.g-block-body-line-dot-right__line {
		.line-dot-card-line();
	}

	.g-block-body-line-dot-right__dot {
		.line-dot-card-dot();
	}

	.g-block-body-line-dot-right__title {
		.line-dot-card-title();
	}

	.g-block-body-line-dot-right__text {
		.line-dot-card-text();

		:deep(.g-rich-text-editable__content) {
			color: inherit;
		}
	}

	.g-block-body-line-dot-right__footer {
		.line-dot-card-footer();
	}

	.g-block-body-line-dot-right--h5 {
		.g-block-body-line-dot-right__card {
			.line-dot-card-shell--h5();
		}
		.g-block-body-line-dot-right__head {
			.line-dot-card-head--h5();
		}
		.g-block-body-line-dot-right__line {
			.line-dot-card-line--h5();
		}
		.g-block-body-line-dot-right__dot {
			.line-dot-card-dot--h5();
		}
		.line-dot-card-title--h5(~'.g-block-body-line-dot-right__title');
		.body-text-base--h5(~'.g-block-body-line-dot-right__text');
		.g-block-body-line-dot-right__footer {
			.line-dot-card-footer--h5();
		}
	}
</style>
